<template>
  <div>
    <div class="wrapper wrapper-content wrapper-scoping-dashboard" v-for="stage in stages" :key="stage.id">
      <h2>
        {{ stage.name }}
        <button
          type="button"
          data-toggle="collapse"
          :data-target="`#collapseBusinessReview${stage.id}`"
          aria-expanded="true"
          aria-controls="collapseBusinessReview"
          class="collapse-kanban"
        >
          <i class="mi keyboard_arrow_down"></i>
        </button>
      </h2>

      <div class="collapse in show" :id="`collapseBusinessReview${stage.id}`">
        <section class="kanban">
          <div class="scroll-container">
            <div v-for="(status, index) in stage.statuses" :key="index" :class="`column ${colourForColumn(index)}`">
              <h2>{{ status.name }}</h2>

              <div class="card-container">
                <draggable
                  v-model="status.projects"
                  :data-status-id="status.id"
                  class="drag-area"
                  :options="{ group: 'stories', ghostClass: 'ghost-class' }"
                  @add="projectChangedStatus"
                >
                  <project-tile
                    :project="project"
                    v-for="project in projectsForStatus(status.id)"
                    :key="`${project.id}.1`"
                  ></project-tile>
                </draggable>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.drag-area {
  min-height: 200px;
}
</style>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import ProjectTile from '../projects/ProjectTile.vue'
import { Selectize, LaddaButton } from 'components/form/input'
import { notify } from 'utils'
import { filter } from 'lodash'
import { SET_PROJECTS_STATUS } from 'vx/mutations'
import { echo } from 'mixins'

export default {
  mixins: [echo],

  data: function () {
    return {
      addProject: null,
    }
  },

  components: {
    draggable,
    ProjectTile,
    Selectize,
    LaddaButton,
  },

  async created() {
    this.echoConnect()
    this.getStages()
    this.getScopingProjects()
  },

  beforeDestroy() {
    this.echoDisconnect()
  },

  computed: {
    ...mapState('stage', ['stages']),
    ...mapState('project', ['projects']),
  },

  methods: {
    ...mapActions('stage', ['getStages']),
    ...mapActions('project', ['getScopingProjects', 'updateProjectStatus']),
    ...mapMutations('project', [SET_PROJECTS_STATUS]),

    connectChannels() {
      this.echo.private('channel').listen('Project.projectStatusUpdatedBroadcast', (e) => {
        this[SET_PROJECTS_STATUS]({ projectId: e.projectId, statusId: e.statusId })
      })
    },

    colourForColumn(column) {
      if (column === 1) {
        return 'red'
      } else if (column === 2) {
        return 'orange'
      } else if (column === 3) {
        return 'blue'
      } else {
        return 'green'
      }
    },

    projectsForStatus(statusId) {
      return filter(this.projects, (project) => {
        return project.project_status_id === statusId
      })
    },

    projectChangedStatus(event) {
      if (event.type === 'add') {
        if (event.item.attributes['data-project-id'] && event.to.attributes['data-status-id']) {
          var projectId = event.item.attributes['data-project-id'].nodeValue
          var statusId = event.to.attributes['data-status-id'].nodeValue
          var payload = {
            id: projectId,
            payload: { status_id: statusId },
          }

          this.updateProjectStatus(payload).catch(() => {
            notify.error('Failed trying to save new status change')
          })
        }
      }
    },
  },
}
</script>
